module.exports = __webpack_public_path__ + "img/austria-infectious-diseases-male.2b04c957.png";